import React from 'react';
import dict from 'config/dictionary';
import externalLinks from 'config/externalLinks';
import { path, pathOr } from 'ramda';
import { interpolate } from './interpolate';

const userFriendlyStatuses = [422, 404, 500];

const supportLink = (
  <a href={externalLinks.email.support.url}>
    {externalLinks.email.support.label}
  </a>
);

export const fallbackError = interpolate(
  dict.unknownAPIError,
  '[support_email]',
  supportLink
);

/**
 * @deprecated This will be removed at some point
 * @param {Object} err
 */
export const translateAPIError = err => {
  let status = Number(path(['response', 'status'], err));
  let message = userFriendlyStatuses.includes(status)
    ? pathOr(
        path(['response', 'data', 'message'], err),
        ['response', 'data', 'error'],
        err
      )
    : null;
  return message || fallbackError;
};
